/**
 * @fileOverview
 * @author iNahoo
 * @since 2018/6/20.
 */
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import DialogWrapper from './DialogWrapper';
import { changeConfirmLocale } from 'antd/lib/modal/locale';
import { BrowserRouter } from 'react-router-dom';
import { history } from '../../utils/router';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import HistoryChangeDestory from './HistoryChangeDestory';

/**
 * Antd 使用了 <body> 来加样式，那我们就用 <html>
 * @type {HTMLElement}
 */
// const LOCKING_ELEMENT = document.body;
// const LOCKING_ELEMENT = document.documentElement;
// 为了解决和ant的冲突，自定义一个根结点
let LOCKING_ELEMENT = document.getElementById('beacon_dialog');

if (!LOCKING_ELEMENT) {
  LOCKING_ELEMENT = document.createElement('div');
  LOCKING_ELEMENT.id = 'beacon_dialog';
  document.body.appendChild(LOCKING_ELEMENT)
}

/**
 * 弹窗实例
 * ------------------
 */
export class Dialog {
  static reservePropsName = {
    destroy: true,
    dispatch: true,
  };

  /**
   * 锁定Body，禁止滚动
   */
  static lockBody = () => {
    LOCKING_ELEMENT.style.overflow = 'hidden';
  };

  /**
   * 解除Body锁定，允许滚动
   */
  static unlockBody = () => {
    if (LOCKING_ELEMENT.style.overflow === 'hidden') {
      LOCKING_ELEMENT.style.overflow = '';
    }
  };

  /**
   * 判定Body是否已经处于锁定状态
   * @returns {boolean}
   */
  static isBodyinLocking = () => LOCKING_ELEMENT.style.overflow === 'hidden';

  /**
   * @param Component
   * @param props
   * @param configs
   */
  constructor(Component, props = {}, configs = {}) {
    this.__configs = configs;
    this.__props = props;
    this.__callback = () => {
      // noop
    };

    /**
     * 因为Antd使用 overflow:hidden 来阻止body滚动
     * 而本弹窗属于Antd规划外的样式控制
     * 所以弹窗组件不再定义单独的状态，直接使用 document.body 的样式来判定是否解除 hidden
     * @type {boolean}
     */
    this.isLastDialog = !Dialog.isBodyinLocking();

    const { allowScroll = false } = this.__configs;

    if (!allowScroll && this.isLastDialog) Dialog.lockBody();
    this.__el = document.createElement('div');
    document.body.appendChild(this.__el);

    /**
     * Props是否包含保留字
     */
    Object.keys(props).forEach((key) => {
      if (key in Dialog.reservePropsName) {
        console.warn(`props中含有保留字段:${key},该字段不会生效`);
      }
    });

    const mappingProps = {
      ...props,
      destroy: this.destroy,
      dispatch: this.dispatch,
    };

    const mappingConfigs = {
      ...configs,
      destroy: this.destroy,
      dispatch: this.dispatch,
    };

    render(
      this.render(Component, mappingProps, mappingConfigs),
      this.__el
    );
  }

  render(Component, props, configs) {
    return (<DialogWrapper {...configs}>
      <BrowserRouter history={history}>
        <HistoryChangeDestory destroy={props.destroy}>
          <Component {...props} />
        </HistoryChangeDestory>
      </BrowserRouter>
    </DialogWrapper>);
  }

  callback(fn) {
    this.__callback = fn;
    return this;
  }

  dispatch = (type, data) => {
    this.__callback(type, data);
  };

  destroy = () => {
    const el = this.__el;
    const { allowScroll } = this.__configs;

    const unmountResult = unmountComponentAtNode(el);
    if (!allowScroll && this.isLastDialog) Dialog.unlockBody();
    if (unmountResult && el.parentNode) {
      el.parentNode.removeChild(el);
    }

    changeConfirmLocale(zhCN && zhCN.Modal);
  };

  static create(Component, defConfigs = {}) {
    return (props, configs = {}) => new this.prototype.constructor(Component, props, {
      ...defConfigs,
      ...configs,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/FunctionalDialog/index.js